export default __webpack_public_path__ + "static/media/error.b04bd2c3.svg";